import { useTranslation } from "react-i18next";
import { categories, categoryImages } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();
  const imageMap = Object.fromEntries(categoryImages.map((ci) => [ci.id, ci.image]));

  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{t("home.categoriesTitle")}</h2>
        <p className="mt-3 text-foreground-600">{t("home.categoriesSubtitle")}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {categories.map((c) => (
          <a
            key={c.id}
            href={c.url}
            target="_blank"
            rel="noopener nofollow"
            className="group rounded-xl border border-background-200 bg-background-50 overflow-hidden transition-all hover:-translate-y-1 cursor-pointer"
          >
            <div className="relative h-40 overflow-hidden">
              <img
                src={imageMap[c.id]}
                alt={`${t(`cat.${c.id}`)} fan merchandise`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-4 flex items-center justify-between gap-3">
              <div className="min-w-0">
                <span className="block text-sm font-semibold text-foreground-950 leading-snug">{t(`cat.${c.id}`)}</span>
                <span className="mt-0.5 block text-xs text-foreground-500">{t(`cat.${c.id}.desc`)}</span>
              </div>
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}